import DC from "../../common/DataConnector";
import { reducerConfLoad } from "./AppConfReducer";

export async function appConfLoad(dispatch: any) {
    let result = await DC.Get('/customer/wapp-conf');
    if (result.wasOk) {
        dispatch(reducerConfLoad(result.data));
    }
}